<script lang="ts">
  import Card from '@smui/card';
  import type { Options } from '@splidejs/splide';
  import { Splide, SplideSlide } from '@splidejs/svelte-splide';
  import { isDirectionRTL } from '../../../common/util';
  import { getImageAltText, getStyle, showTileInfo } from '../services/pdp-data-services';
  export let keyHighlights;

  const isRTL = isDirectionRTL();

  const mobileSliderOption: Options = {
    type: 'slide',
    direction: 'ttb',
    fixedWidth: '90px',
    fixedHeight: '102px',
    height: '27rem',
    perPage: 2,
    arrows: false,
    gap: '8px',
    pagination: false,
    wheel: true,
    cover: true,
    isNavigation: true,
    releaseWheel: true,
    breakpoints: {
      760: {
        perPage: 4,
      },
    },
  };
</script>

{#if keyHighlights != null && keyHighlights.length > 0}
  <div class="d-flex justify-content-center">
    <Splide options={{ ...mobileSliderOption }}>
      {#each keyHighlights as slide, i}
        <SplideSlide>
          <div class="card-container">
            <Card
              on:click={() => showTileInfo(i)}
              on:keydown={() => showTileInfo(i)}
              style={`background:${slide.background || 'transparent'}; width:auto;`}
            >
              {#if slide.backgroundImage}
                <img
                  class="card-background-image"
                  src={slide.backgroundImage}
                  alt={getImageAltText(slide.backgroundImage)}
                />
              {/if}
              <div class="inner-details" class:rtl={isRTL}>
                {#if slide?.icon}
                  <!-- <Icon glyph={slide.icon} size={10} /> -->
                  <img src={slide.icon} alt="" />
                {/if}
                {#if slide?.title}
                  <div class="mdc-typography--headline6" style={getStyle(slide?.titleColorCode, 'title')}>
                    {slide?.title}
                  </div>
                {/if}
                {#if slide?.description}
                  <div class="mdc-typography--caption" style={getStyle(slide?.descriptionColorCode, 'description')}>
                    {slide?.description}
                  </div>
                {/if}
              </div>
            </Card>
          </div>
        </SplideSlide>
      {/each}
    </Splide>
  </div>
{/if}

<style lang="scss">
  * :global(.mdc-card) {
    height: 102px;
    border-radius: 12px;
  }

  :global(.splide) {
    margin: 0 !important;
  }
  .mdc-typography--caption {
    font-weight: 400;
    font-size: 11px;
    line-height: 12px;
    padding: 0 10px;
  }

  img {
    padding: 0 0 4px 10px;
    width: 24px;
    height: 24px !important;
  }

  .mdc-typography--headline6 {
    font-weight: 700;
    font-size: 14px;
    line-height: 16px;
    padding: 0 10px;
    margin-bottom: 2px;
  }

  .card-container {
    :global(.mdc-card) {
      position: relative;
      overflow: hidden;
    }

    .card-background-image {
      position: absolute;
      inset: 0;
      padding: 0;
      width: 100% !important;
      height: 100% !important;
      object-fit: cover;
      z-index: 0;
    }

    .inner-details {
      position: relative;
      z-index: 1;
      padding-top: 12px;
      &.rtl {
        img {
          padding: 0 10px 4px 0;
        }
      }
    }
  }
</style>
